export class MessageReceiver {
  public id: string;
  public receiver: string;
  public name: string;
}
